import { useEffect } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import { dramas } from "@/mocks/dramas";
import HeroCarousel from "./components/HeroCarousel";
import CategoryGrid from "./components/CategoryGrid";
import LatestSection, { HotSection, UpdateTimeline } from "./components/ContentSections";
import IntroSection from "./components/IntroSection";

const heroIds = ["silent-tide", "borrowed-light", "showa-kitchen", "white-noise-ward"];
const heroItems = heroIds
  .map((id) => dramas.find((item) => item.id === id))
  .filter((item): item is (typeof dramas)[number] => Boolean(item));

const HOME_TDK = {
  title: "日本伦理剧-精选日本伦理题材电视剧与影视作品",
  description:
    "日本伦理剧网站专注于提供丰富的日本伦理题材电视剧和影视内容，涵盖多种剧情类型，帮助用户了解和观看相关作品，体验独特的文化故事。",
  keywords: "日本伦理剧,日本伦理电视剧,日本伦理影视,日本伦理剧情,日本伦理剧推荐,日本伦理剧作品,日本伦理剧大全",
};

function setMeta(name: string, content: string, attr: "name" | "property" = "name") {
  let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export default function Home() {
  useEffect(() => {
    document.title = HOME_TDK.title;
    setMeta("description", HOME_TDK.description);
    setMeta("keywords", HOME_TDK.keywords);
    setMeta("og:title", HOME_TDK.title, "property");
    setMeta("og:description", HOME_TDK.description, "property");
    setMeta("og:type", "website", "property");
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroCarousel items={heroItems} />
        <CategoryGrid />
        <LatestSection />
        <HotSection />
        <UpdateTimeline />
        <IntroSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}